import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { map, Observable, tap } from 'rxjs';
import { EntityItemTypedInterface } from 'src/app/shared/components/search-input/select-item.interface';
import { ClinicService } from 'src/app/shared/services/clinic.service';
import { ClinicInterface } from '../../models/clinic.interface';

@Component({
  selector: 'app-clinic-search',
  templateUrl: './clinic-search.component.html',
  styleUrls: ['./clinic-search.component.scss']
})
export class ClinicSearchComponent implements OnInit {
  @Output() clinicSelected = new EventEmitter<{ name: string; clinic?: ClinicInterface | undefined; zipCode: string }>();

  clinicFormGroup = new FormGroup({
    zipCode: this.formBuilder.control('', [Validators.required, Validators.pattern('[0-9]{5}')]),
  });

  textSearchFormControl = new FormControl<{ id: number; label: string } | undefined>(undefined);
  searchText?: string;
  onFilterClinics: (args: string) => Observable<EntityItemTypedInterface<ClinicInterface>[]>;

  constructor(
    private readonly clinicService: ClinicService,
    private readonly formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.onFilterClinics = (value: string) => {
      this.searchText = value.trim();
      return this.clinicService
        .searchAllClinicsByZipcode(
          value,
          this.clinicFormGroup.controls.zipCode.value ?? ''
        )
        .pipe(
          map((clinics) =>
            clinics?.map(clinic => {
              const entity: EntityItemTypedInterface<ClinicInterface> = {
                id: clinic.id,
                object: clinic,
                label: `${clinic.name} - ${clinic.city} ${clinic.phone ? ' - ' + clinic.phone : ''} ${!clinic.isMyPacs ? ' - LofVet' : ''}`,
                color: clinic.isMyPacs ? '' : 'orange'
              };
              return entity;
            })
          ),
          tap(s => {
            s.push({ object: undefined, id: -1, label: '+ Créer une nouvelle clinique' });
            return s;
          })
        );
    };

    this.textSearchFormControl.disable();

    this.clinicFormGroup.controls.zipCode.statusChanges.subscribe(status => {
      if (status === 'VALID') {
        this.textSearchFormControl.enable();
      } else {
        this.textSearchFormControl.disable();
        this.textSearchFormControl.setValue(undefined);
      }
    });
  }

  onSelectedUserClinicChanged(event: EntityItemTypedInterface<ClinicInterface>) {
    if (!event) {
      this.clinicSelected.emit(undefined);
      return;
    }

    this.clinicSelected.emit({
      clinic: event.object,
      name: this.searchText ?? '',
      zipCode: this.clinicFormGroup.controls.zipCode.value ?? ''
    });
  }
}
